export const getMillisecondsToDateAtMidnight = (dateString: string) =>
  new Date(dateString).setUTCHours(0, 0, 0, 0);
